import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  FormArray
} from '@angular/forms';
import { PlansService } from '../services/plans.service';
import { AuthenticationService } from '../services/authentication.service';
import { IntellectualpropertyService } from '../services/intellectualproperty.service';

@Component({
  selector: 'app-intellectualproperty',
  templateUrl: './intellectualproperty.component.html',
  styleUrls: ['./intellectualproperty.component.css']
})
export class IntellectualpropertyComponent implements OnInit {

  pageTitle = 'Propiedad Intelectual';
  nameProperty = '';

  formRef: FormGroup;

  constructor(
    private intPropertyService: IntellectualpropertyService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.createForm();
  }
  createForm() {
    this.formRef = this.formBuilder.group({
      nameProperty: ['', Validators.required]
    });
  }

  saveSettings() {
    if (this.formRef.valid) {
      const id = Date.now();
      const property = {
        pid: id,
        name: this.nameProperty,
        status: 'activo'
      };
      this.intPropertyService.setProperty(property).then(
        () => {
          alert('Creado satisfactoriamente');
          this.cleanForm();
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  cleanForm() {
    this.createForm();
  }
}
